import { QUIZ_URL } from "../../constants";
import { apiSlice } from "../apiSlice";

const quizAdminSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    submitGeneralFeedback: builder.mutation({
      query: (data) => ({
        url: `${QUIZ_URL}/admin/general_feedback`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Feedback'],
    }),
    submitQuestionFeedback: builder.mutation({
      query: (data) => ({
        url: `${QUIZ_URL}/admin/question_feedback`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Feedback'],
    }),
    getGeneralFeedback: builder.query({
      query: () => ({
        url: `${QUIZ_URL}/admin/general_feedback`,
      }),
      keepUnusedDataFor: 5,
      providesTags: ['Feedback'],
    }),
    getQuestionFeedback: builder.query({
      query: () => ({
        url: `${QUIZ_URL}/admin/question_feedback`,
      }),
      keepUnusedDataFor: 5,
      providesTags: ['Feedback'],
    }),
    updateQuestion: builder.mutation({
      query: (data) => ({
        url: `${QUIZ_URL}/admin/question_feedback`,
        method: 'PUT',
        body: data
      })
    }),
    updateUserPassword: builder.mutation({
      query: (data) => ({
        url: `${QUIZ_URL}/admin/update_user_password`,
        method: 'PUT',
        body: data
      })
    }),
  }),
});

export const { 
    useSubmitGeneralFeedbackMutation,
    useSubmitQuestionFeedbackMutation,
    useLazyGetGeneralFeedbackQuery,
    useLazyGetQuestionFeedbackQuery,
    useUpdateQuestionMutation,
    useUpdateUserPasswordMutation,
} = quizAdminSlice;
